import { DbObjectBase } from './db-object-base';
import { ICollectionReference } from '../database-cast/IDatabase';
import { MethodCoverWhell } from '../../_shared/models/method-task';
export class DbMethodCoverWhell extends DbObjectBase<MethodCoverWhell> {
    constructor(id: string, colllection: ICollectionReference) {
        super(id, colllection);
    }
}
